<template>
    <div class="landing__main p--0">
        <div class="bg-main relative normal h--100 flex flex-column justify-content-between">
            <div>
                <LandingHeader :no-inner-padding="false" class="pt--10" />

                <div class="l_s_b mt--20">
                    <div class="grid l_s_w">
                        <div class="l_s_w_l flex-1">
                            <div class="mt--20" style="max-width: 90%;">
                                <h1 class="text--bold">
                                    Contact Us
                                </h1>
                                <p class="mt--10 text--normal text-gray-600">
                                    Having a hard time with our app? Tell us a bit more about the issue you are facing.
                                </p>
                            </div>

                            <div class="mt--40">
                                <p class="text-gray-800 text--md text--capitalize text--semi--bold">
                                    Talk to us about
                                </p>
                                <ol class="mt--5" type="1">
                                    <li class="text-gray-600 text--sm mb--5">
                                        1. How our product can be aligned with your needs as a creator
                                    </li>
                                    <li class="text-gray-600 text--sm mb--5">
                                        2. Suggestions or complaints
                                    </li>
                                    <li class="text-gray-600 text--sm">
                                        3. Getting a personalized demo to understand how Ziner works
                                    </li>
                                </ol>
                            </div>

                            <div class="mt--40">
                                <p class="text-gray-800 text--md text--capitalize text--semi--bold">
                                    Other contact info
                                </p>
                                <div class="flex align-items-center mt--10">
                                    <div class="l_s_w_icon">
                                        <IconSvg name="envelope" />
                                    </div>
                                    <p class="text-gray-600 text--sm">
                                        support@ziner.cc
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="l_s_w_r flex-1">
                            <SupportForm :issue-type="issueType" />
                        </div>
                    </div>
                </div>
            </div>

            <LandingFooter 
                id="footer" 
                class="landing__footer mt--40" 
                :show-bg-toggle="false"
            />
        </div>
    </div>
</template>

<script>
import { IconSvg } from "@/components/ui/index";
import LandingFooter from "@/components/home/LandingFooter.vue";
import LandingHeader from "@/components/home/LandingHeader.vue";
import SupportForm from "@/components/home/support/SupportForm.vue";

export default {
    name: "SupportPage",

    components: {
        SupportForm, 
        LandingFooter,
        IconSvg, 
        LandingHeader,
    },
    
    data() {
        return {
            isTransform: false,
            issueType: "",
        };
    },

    mounted() {
        if (this.$route.query?.query) {
            const query = this.$route.query.query.split(" ").join("_");            
            this.issueType = query;
        }
    },

    methods: {
        transformIcon() {
            this.isTransform = !this.isTransform;
            this.showMobileNav = !this.showMobileNav;
        },
    },
};
</script>